<i18n>
{
	"en": {
		"failedToFetch": "Failed to fetch cargo carrier types",
		"cargoCarrierTypes": "Cargo carrier types",

		"icon": "Icon",
		"r10Id": "TMS ID",
		"code": "Type",
		"description": "Description",
		"information": "information",
		"loadingVolume": "Loading volume",
		"loadingWeight": "Loading weight",
		"width": "Width",
		"length": "Length",
		"height": "Height",
		"wareCode": "Ware code",
		"priceCode": "Price code",
		"priceCode2": "Price code 2",
		"priceCode3": "Price code 3",
		"priceCode4": "Price code 4",
		"priceCode5": "Price code 5",

		"yes": "Yes",
		"no": "No",

		"updatedIcon": "Updated icon",
		"faieldToUpdateIcon": "Failed to update icon"

	},
	"no": {
		"failedToFetch": "Kunne ikke hente lastebærertyper",
		"cargoCarrierTypes": "Lastbærertyper",

		"icon": "Ikon",
		"r10Id": "TMS ID",
		"code": "Type",
		"description": "Beskrivelse",
		"information": "Informasjon",
		"loadingVolume": "Volum",
		"loadingWeight": "Lastevekt",
		"width": "Bredde",
		"length": "Lengde",
		"height": "Høyde",
		"wareCode": "Varekode",
		"priceCode": "Priskode",
		"priceCode2": "Priskode 2",
		"priceCode3": "Priskode 3",
		"priceCode4": "Priskode 4",
		"priceCode5": "Priskode 5",

		"yes": "Ja",
		"no": "Nei",

		"updatedIcon": "Ikonet ble oppdatert",
		"failedToUpdateIcon": "Kunne ikke oppdatere ikon"

	}
}
</i18n>

<template>
	<t-vertical-panel class="cargo-carrier-types">
		<div
			slot="header"
			class="cargo-carrier-types-header"
		>
			<t-panel-header
				size="md"
				icon="truck-front"
			>
				{{ $t('cargoCarrierTypes') }}
			</t-panel-header>
		</div>

		<div class="cargo-carrier-types-content">
			<t-grid
				v-if="cargoCarrierTypes"
				ref="grid"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="40"
				:items="cargoCarrierTypes"
				localStorageId="cargoCarrierTypesList"
			>
				<template #iconId="{ item }">
					<t-select
						:selectedItem="item.iconId"
						:items="cargoCarriersIcons"
						appearance="minimal"
						relative
						disableBoxShadow
						@select="updateCargoCarrierTypeIcon({
							cargoCarrierType: item,
							iconId: $event
						})"
					>
						<template #displayedValue="{ popoverShow }">
							<div class="icon-wrapper">
								<t-timpex-icon
									v-if="!item.iconId && !popoverShow"
									icon="unknown-vehicle"
									type="bp"
									color="orange"
								/>
								<t-timpex-icon v-else :icon="getCargoCarrierTypeIcon(item.iconId)" color="neutral" />
							</div>
						</template>
						<template #optionItem="slotProps">
							<t-menu-combobox-option-item
								:value="slotProps.item"
								:selected="slotProps.isSelected"
							>
								<t-timpex-icon :icon="getCargoCarrierTypeIcon(slotProps.item)" color="neutral" />
							</t-menu-combobox-option-item>
						</template>
					</t-select>
				</template>

			</t-grid>
		</div>
	</t-vertical-panel>
</template>

<script>

import { cargoCarrierIcon } from '@/core';


import TVerticalPanel from '@/components/evergreen/timpex/layers/TVerticalPanel';
import TPanelHeader from '@/components/evergreen/timpex/layers/TPanelHeader';
import TGrid from '@/components/evergreen/timpex/grid/TGrid';

import {
	mapActions,
	mapState,
} from '@/modules/cargoCarrierTypes/store/cargoCarrierTypes.store';
import TSelect from '@/components/evergreen/inputs/TSelect';
import TTimpexIcon from '@/components/evergreen/timpex/icons/TTimpexIcon';
import TMenuComboboxOptionItem from '@/components/evergreen/menu/TMenuComboboxOptionItem';

export default {
	name: 'CargoCarrierTypes',
	components: { TMenuComboboxOptionItem, TTimpexIcon, TSelect, TGrid, TPanelHeader, TVerticalPanel },
	data() {
		return {
			cargoCarriersIcons: Object.values(cargoCarrierIcon.iconIds),
			rowsSelected: 0,
			defaultColumnDefinition: { resizable: true },
		};
	},
	computed: {
		...mapState([
			'cargoCarrierTypes',
			'loading',
			'errors'
		]),
		columnDefinitions() {
			return [
				{
					field: 'iconId',
					displayName: this.$t('icon'),
					width: 126,
				}, {
					field: 'r10Id',
					displayName: this.$t('r10Id'),
					width: 70,
				}, {
					field: 'code',
					displayName: this.$t('code'),
					width: 70,
				}, {
					field: 'description',
					displayName: this.$t('description'),
				}, {
					field: 'information',
					displayName: this.$t('information'),
				}, {
					field: 'loadingVolume',
					displayName: this.$t('loadingVolume'),
				}, {
					field: 'loadingWeight',
					displayName: this.$t('loadingWeight'),
				}, {
					field: 'width',
					displayName: this.$t('width'),
					width: 60,
				}, {
					field: 'length',
					displayName: this.$t('length'),
					width: 60,
				}, {
					field: 'height',
					displayName: this.$t('height'),
					width: 60,
				},  {
					field: 'wareCode',
					displayName: this.$t('wareCode'),
					width: 90,
				},{
					field: 'priceCode',
					displayName: this.$t('priceCode'),
					width: 90,
				}, {
					field: 'priceCode2',
					displayName: this.$t('priceCode2'),
					width: 90,
				}, {
					field: 'priceCode3',
					displayName: this.$t('priceCode3'),
					width: 90,
				}, {
					field: 'priceCode4',
					displayName: this.$t('priceCode4'),
					width: 90,
				}, {
					field: 'priceCode5',
					displayName: this.$t('priceCode5'),
					width: 90,
				}
			];
		}
	},
	async mounted() {
		try {
			await this.getCargoCarrierTypes();
		} catch (e) {
			this.$notify({
				type: 'error',
				duration: -1,
				title: this.$t('failedToFetch')
			});
		}
	},
	methods: {
		...mapActions([
			'getCargoCarrierTypes',
			'setCargoCarrierType',
		]),

		getCargoCarrierTypeIcon(iconId) {
			return cargoCarrierIcon.getIcon(iconId);
		},
		async updateCargoCarrierTypeIcon({ cargoCarrierType, iconId }) {
			try {
				await this.setCargoCarrierType({
					cargoCarrierType,
					prop: 'iconId',
					data: iconId,
				});
				this.$notify({
					type: 'success',
					title: this.$t('updatedIcon'),
					text: cargoCarrierType.description
				});
			} catch (e) {
				console.log(e);
				this.$notify({
					type: 'error',
					title: this.$t('failedToUpdateIcon'),
					text: cargoCarrierType.description
				});
			}
		},
	}
};
</script>

<style lang="scss" scoped>
.cargo-carrier-types {
	.cargo-carrier-types-header {
		height: 100%;
		display: flex;
		align-items: center;
		padding-left: 15px;
	}
	.cargo-carrier-types-sub-header {
		display: flex;
		padding: 0 15px;
		height: 100%;
		align-items: center;
		justify-content: flex-end;

		> button {
			margin: 10px;
		}
	}
	.cargo-carrier-types-content {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 5px;
	}
}

.icon-wrapper {
	height: 100%;
	display: flex;
	justify-content: flex-start;
}
</style>
